import { render } from "./AddToStarred.vue?vue&type=template&id=ffe79146"
import script from "./AddToStarred.vue?vue&type=script&lang=js"
export * from "./AddToStarred.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__